var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{staticClass:"lfs-snackbar",staticStyle:{"z-index":"5000"},attrs:{"bottom":"","right":"","timeout":_vm.time,"value":_vm.show,"color":_vm.colorAl  === 'red' ? 'red' : '#2196F31F'}},_vm._l((_vm.messages),function(item,idx){return _c('p',{key:'alert' + idx,style:({
    color: _vm.colorAl === 'red' ? 'white' : '#2D9CDB'
     })},[_vm._v("\n    "+_vm._s(item)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }